import { addListStyles } from "@collectivehealth/dls-dropdowns";
import epSelect from "./epSelect.css";

addListStyles([
  {
    attributeName: "theme",
    attributeValue: "ep-select",
    className: "ignore",
    styles: epSelect.toString(),
    parts: {
      listItemContent: epSelect.locals.listItemContent
    }
  }
]);
